import {fetchJson} from '@sinclair-digital/sbg-util/dist/es/fetch';
import {memoizeWith, prop} from 'ramda';

/**
 * Returns the current environment
 *
 * @param {Object} frontendStoryLineConfig
 * @property {string} frontendStoryLineConfig.environment
 * @returns {'int'|'qa'|'prod'}
 */
export const getEnv = (frontendStoryLineConfig = window.frontendStoryLineConfig) =>
  frontendStoryLineConfig.environment.toLowerCase();

const stlSettingUrlsByEnvironment = {
  'int': 'https://stl-settings.int-sinclairstoryline.com',
  'qa': 'https://stl-settings.qa-sinclairstoryline.com',
  'prod': 'https://stl-settings.sinclairstoryline.com',
};

/**
 * Creates an URL for fetching settings
 *
 * @param {URL} _url
 * @param {string} env
 * @returns {string}
 */
const getSettingsUrl = (_url, env) =>
  `${stlSettingUrlsByEnvironment[env || 'int'] ?? stlSettingUrlsByEnvironment.int}/${env || 'int'}/settings`;

const fetchSettings = () =>
  fetchJson(getSettingsUrl(window.location, getEnv()));

const FIVE_MINUTES_MS = 5 * 60 * 1000;

/**
 * Returns a different number every five minutes
 * @param {number} milliseconds since epoch
 * @returns {number}
 */
const getCurrentStep = (milliseconds = Date.now()) => Math.floor(milliseconds / FIVE_MINUTES_MS);

export const getAllSettings = memoizeWith(getCurrentStep, fetchSettings);

/**
 * @param {string} key
 * @returns {Promise<string>}
 */
export const getSetting = (key) =>
  getAllSettings().then(prop('settings')).then(prop(key));

const createSetting = (key, val, now) => ({
  key,
  setting: val,
  date: now.toISOString(),
  user: 'storyline',
});

/**
 * @param {string} key
 * @param {string} val
 * @returns {Promise<Response>}
 */
export const setSetting = (key, val) =>
  fetchJson(getSettingsUrl(window.location, getEnv()), {
    method: 'PUT',
    body: JSON.stringify(createSetting(key, val, new Date())),
  });

// tslint:disable-next-line
export const __testExports = {
  getSettingsUrl,
  createSetting,
  getEnv,
  getCurrentStep,
};
